module.exports = __webpack_public_path__ + "static/media/ticket-thats.d44908d9.svg";